var _desc, _defs, _rect, _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(19.7628 0 0 19.7628 499.9989 499.9989)",
    id: 273790
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.2085 0.3847)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 22.6008
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.2085 0.3848)",
    clipPath: "url(#CLIPPATH_1)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_1"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "clip0_45_8167",
    x: -13,
    y: -13.5,
    rx: 0,
    ry: 0,
    width: 26,
    height: 27
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(97,64,178)",
      fillOpacity: 0.54,
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-22.7915, -23.3848)",
    d: "M 22.7915 18.8848 C 23.9886 18.8848 24.9582 17.8779 24.9582 16.6348 C 24.9582 15.3916 23.9886 14.3848 22.7915 14.3848 C 21.5944 14.3848 20.6248 15.3916 20.6248 16.6348 C 20.6248 17.8779 21.5944 18.8848 22.7915 18.8848 Z M 22.7915 21.1348 C 21.5944 21.1348 20.6248 22.1416 20.6248 23.3848 C 20.6248 24.6279 21.5944 25.6348 22.7915 25.6348 C 23.9886 25.6348 24.9582 24.6279 24.9582 23.3848 C 24.9582 22.1416 23.9886 21.1348 22.7915 21.1348 Z M 22.7915 27.8848 C 21.5944 27.8848 20.6248 28.8916 20.6248 30.1348 C 20.6248 31.3779 21.5944 32.3848 22.7915 32.3848 C 23.9886 32.3848 24.9582 31.3779 24.9582 30.1348 C 24.9582 28.8916 23.9886 27.8848 22.7915 27.8848 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseButton);
export default __webpack_public_path__ + "static/media/collapse-button.64ac28f325010d8f472655c10249a52c.svg";
export { ForwardRef as ReactComponent };